module.exports = __webpack_public_path__ + "static/media/step-check-green.75d8c9ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Stepper/assets/step-check-green.svg
// module id = 1500
// module chunks = 193